import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown"
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput"
import { useTranslation } from "react-i18next";
import enableArrow from '../../../../../../assets/smi-kudzu-images/enable_arrow.png'
import disableArrow from '../../../../../../assets/smi-kudzu-images/disable_arrow.png'
import { handleAmountInputLimitTo2decimal } from 'utils';
import CustomDatePicker from 'components/CustomComponents/CustomDateInput';
import Yellow from '../../../../../../assets/smi-kudzu-images/yellow.png'

const AddBiller = ({ frequency, onSearchBiller, onCancelClick, onNextClick, addBillerList, addBillerInfo, addBillerSubbmit , addNewBiller}) => {
    const SelectedBillers = useSelector(state => state.selectedBillerType);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');
    const bills = useSelector(x => x.billerTypesList);
    const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
    const searchTimeoutRef = useRef(null);
    const primaryAcc = useSelector(x => x.primaryAccount)
    const billPaymentsMetaData = useSelector(x => x.billPaymentsMetaData)
    const isNextDisabled = !SelectedBillers || Object.keys(SelectedBillers || {}).length === 0;
    const [enteredAccNumber, setEnteredAccountNumber] = useState()
    const [reEnteredAccNumber, setReEnteredAccNumber] = useState()
    const [enteredAccErr, setEnteredAccErr] = useState('');
    const [reEnterErrMesg, setReEnterErrMsg] = useState('')
    const [selectedFrequency, setSelectedFrequency] = useState()
    const [enteredAmount, setEnteredAmount] = useState()
    const [oneTimeSelectedDate, setOneTimeSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const selectedBiller = useSelector(con => con.selectedBillerType);
    
    useEffect(() =>{
      dispatch({ type: 'SELECTED_BILLER_TYPE', payload: { selectedBillerType: '' } });
    },[])

    const handleOnBlurEnteredAccountNumberInfo = (e) => {
        if (!enteredAccNumber || enteredAccNumber.trim().length === 0) setEnteredAccErr('Please enter account number');
        else setEnteredAccErr('')
    }

    const handleOnBlurRe_EnteredAccountNumberInfo = (e) => {
        if (!reEnteredAccNumber || reEnteredAccNumber.trim().length === 0) setReEnterErrMsg('Please enter re account number');
        else setReEnterErrMsg('')
    }

    const onDateChange = (date, type) => {
        if (type == 'oneTime') {
            setOneTimeSelectedDate(date)
            dispatch({ type: 'BILL_PAYMENT_ONE_TIME', payload: { billPaymentOneTimeDate: date } })
        } else if (type == 'recurringStartDate') {
            setStartDate(date)
            dispatch({ type: 'BILL_PAYMENT_RC_START', payload: { billPaymenRCStartDate: date } })
            setEndDate(null)
            dispatch({ type: 'BILL_PAYMENT_RC_END', payload: { billPaymenRCEndDate: null } })
        } else if (type == 'recurringEndDate') {
            setEndDate(date)
            dispatch({ type: 'BILL_PAYMENT_RC_END', payload: { billPaymenRCEndDate: date } })
        }
    }



    // End date must be at least the day after start date
    const endDateMinDate = startDate ? (() => {
        const d = new Date(startDate);
        d.setDate(d.getDate() + 1);
        return d;
    })() : undefined;


    // Submit disabled until account numbers (matching), frequency, amount, and dates are filled
    const hasAccountNumber = (enteredAccNumber ?? '').trim().length > 0;
    const hasReEnteredAccountNumber = (reEnteredAccNumber ?? '').trim().length > 0;
    const accountNumbersMatch = hasAccountNumber && hasReEnteredAccountNumber && (enteredAccNumber ?? '').trim() === (reEnteredAccNumber ?? '').trim();
    const hasFrequency = selectedFrequency != null && Object.keys(selectedFrequency).length > 0;
    const hasAmount = Boolean(enteredAmount) && parseFloat(String(enteredAmount).replace(/[$,]/g, '')) > 0;
    const hasDates = selectedFrequency?.Type === 'O'
        ? Boolean(oneTimeSelectedDate)
        : Boolean(startDate && endDate);
    const isSubmitDisabled = !hasAccountNumber || !hasReEnteredAccountNumber || !accountNumbersMatch || !hasFrequency || !hasAmount || !hasDates;




    return (
        <>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
                            animate__animated animate__fadeInRight '>
                <div className='md:w-[100%] sm:w-[100%] w-full '>
                    {addBillerList &&

                        <div className={`flex flex-col sm:mx-0 mx-4`}>
                                      {!kudzuPlusTrue && (
                                <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                            )}
                            <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('BILL_PAYMENTS_ENTER_BILLER_DETAILS'))}</p>
                            </div>

                            <div className='flex justify-center'>
                                <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>
                                    <div className='mb-20 mt-20'>
                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Search Biller")}</p>
                                        <CustomTextInput
                                            value={searchValue}
                                            onFocus={() => setIsSearchDropdownOpen(true)}
                                            onChange={(event) => {
                                                // setIsSearchDropdownOpen(true) // need to remove onFocus is enogh

                                                const inputValue = event.target.value ?? '';
                                                setSearchValue(inputValue);
                                                if (!onSearchBiller) return;
                                                if (searchTimeoutRef.current) {
                                                    clearTimeout(searchTimeoutRef.current);
                                                }
                                                searchTimeoutRef.current = setTimeout(() => {
                                                    onSearchBiller(inputValue.trim());
                                                }, 500);
                                            }}
                                            inputWidth={`w-full`}
                                        />
                                        {isSearchDropdownOpen && (
                                            <div className="bg-[var(--custom-dropdown-bg)] relative z-10 max-h-[13rem] overflow-y-auto ">
                                                <ul role="listbox">
                                                    <li role="option">
                                                        <button
                                                            type="button"
                                                            className="w-full py-3 px-4 cursor-pointer flex items-center justify-between text-[#2965FB] hover:bg-[var(--selected-hover-bg)] hover:text-[var(--custom-dropdown-hover-text)] font-hanken-grotesk lg:text-[16px] md:text-[15px] sm:text-[13px] text-[14px] bg-transparent border-0 text-left"
                                                            onClick={addNewBiller}
                                                        >
                                                            <span>{t('Add new biller')}</span>
                                                            <span className="text-[22px] text-[#2965FB] leading-[0px] font-[700]" aria-hidden="true">+</span>
                                                        </button>
                                                    </li>

                                                    {(Array.isArray(bills) ? bills : []).map((biller, index) => (
                                                        <li key={`${biller.Type}-${index}`} role="option">
                                                            <button
                                                                type="button"
                                                                className="w-full py-3 px-4 cursor-pointer text-[var(--text-clr-transactions)] hover:bg-[var(--selected-hover-bg)] hover:text-[var(--custom-dropdown-hover-text)] font-hanken-grotesk lg:text-[16px] md:text-[15px] sm:text-[13px] text-[14px] bg-transparent border-0 text-left"
                                                                onClick={() => {
                                                                    dispatch({ type: 'SELECTED_BILLER_TYPE', payload: { selectedBillerType: biller } });
                                                                    setSearchValue(biller.Name || '');
                                                                    setIsSearchDropdownOpen(false);
                                                                }}
                                                            >
                                                                {biller.Name}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='flex flex-row sm:justify-end w-[85%] justify-between mb-16'>
                                <button
                                    type="button"
                                    onClick={onCancelClick}
                                    className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    type="button"
                                    onClick={onNextClick}
                                    disabled={isNextDisabled}
                                    className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                >
                                    {t("Next")}
                                </button>
                                <img src={isNextDisabled ? disableArrow : enableArrow} alt="" aria-hidden="true" className='h-[13px] w-[13px] mt-3 ml-2 mb-2
                      sm:h-[10px] sm:w-[11px] md:h-[13px] md:w-[13px]' />
                            </div>
                        </div>
                    }

                    {addBillerInfo &&
                        <>
                            <div className={`flex flex-col sm:mx-0 mx-4`}>
                                       {!kudzuPlusTrue && (
                                <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                            )}
                                <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                    <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{`Please enter the biller details for ${selectedBiller?.Name}.`}</p>
                                </div>

                                <div className='flex justify-center'>
                                    <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("FROM")}</p>
                                            <CustomDropdown
                                               // title={t('FROM')}
                                                hideArrow={true}
                                                selectedAccountType={primaryAcc}
                                                hrbg='bg-dropdown-sky'
                                                balanceFontColor={kudzuPlusTrue ? 'text-[#ffffff]' :'text-[#559C7E]'} />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Name")}</p>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                textColor={true}
                                                value={SelectedBillers?.Name}
                                                style={{ width: '100%', height: '51px' }}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("BILLER_ACC_NUMBER_TEXT")}</p>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setEnteredAccountNumber(value);
                                                    dispatch({ type: 'ENTERED_ACCOUNT_NUMBER', payload: { enteredAccountNumber: value } });
                                                    // Live-validate match with re-entered account number
                                                    if ((reEnteredAccNumber ?? '').length > 0) {
                                                        if (value !== reEnteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                               // numbersOnly={true}
                                                value={enteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("RE_ENTERED_BILLER_ACC_NUMBER")}</p>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setReEnteredAccNumber(value);
                                                    dispatch({ type: 'RE_ENTERED_ACCOUNT_NUMBER', payload: { reEnteredAccNumber: value } });
                                                    // Live-validate match with first account number
                                                    if ((enteredAccNumber ?? '').length > 0) {
                                                        if (value !== enteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    } else {
                                                        // If first field is empty, clear mismatch error and rely on required validation if any
                                                        setReEnterErrMsg('');
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurRe_EnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                               // numbersOnly={true}
                                                value={reEnteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                                error={reEnterErrMesg}
                                            />
                                        </div>

                                        <div className="mb-8 bg-[#DAE2E8] rounded-lg px-4 py-3 flex items-center gap-3">
                                            <img src={Yellow} alt="Warning" className="w-5 h-5 shrink-0" />
                                            <p className="font-hanken-grotesk font-[600] text-[14px] leading-[20px] text-[#1E1E1E]">
                                                {t("BILL_PAYMENTS_BOTH_ACCOUNT_NUMBERS_SHOULD_MATCH")}
                                            </p>
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Frequency")}</p>
                                            <CustomDropdown
                                                options={frequency || []}
                                                onSelect={(option) => {
                                                    setSelectedFrequency(option)
                                                    dispatch({ type: 'SELECTED_FREQUENCY_TYPE', payload: { selectedFrequencyType: option } });
                                                }}
                                                selectedAccountType={selectedFrequency}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Bill Amount")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
                                                    setEnteredAmount(formattedAmount)
                                                    dispatch({ type: 'BILL_AMOUNT', payload: { billAmount: formattedAmount } });
                                                }}
                                                value={enteredAmount ? `$${enteredAmount}` : ''}
                                                placeholder={"$ 0"}
                                                inputWidth='w-full'
                                            />
                                        </div>

                                        <div className='mb-8'>

                                            {selectedFrequency?.Type === "O" &&
                                                <CustomDatePicker
                                                    selectedDate={startDate}
                                                    onDateChange={(date) => onDateChange(date, 'oneTime')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="Next Payment DATE"
                                                    hrbg="bg-dropdown-sky"
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>
                                        <div className='mb-8'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={startDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringStartDate')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    title="Next Payment DATE"
                                                    hrbg='bg-dropdown-sky'
                                                    disabledDates={[]}
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }

                                        </div>
                                        <div className='mb-12'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={endDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringEndDate')}
                                                    minDate={endDateMinDate}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="End Date"
                                                    hrbg='bg-dropdown-sky'
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>

                                        <div className='flex flex-col gap-4 justify-center items-center w-full mb-20'>
                                            <button
                                                type="button"
                                                onClick={addBillerSubbmit}
                                                disabled={isSubmitDisabled}
                                                className={`font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-white border-2 px-2 py-4 border-[#2965FB] w-full ${isSubmitDisabled ? 'bg-[#94C3E8] border-[#94C3E8] cursor-not-allowed' : "bg-[#2965FB] border-[#2965FB] cursor-pointer"}`}
                                            >
                                                {t("Submit")}
                                            </button>
                                            <button
                                                type="button"
                                                onClick={onCancelClick}
                                                className='focus:outline-none font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-transparent text-[#2965FB] cursor-pointer px-2 py-4 border-0 w-full'
                                            >
                                                {t("Cancel")}
                                            </button>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}
export default AddBiller;